module.exports = __webpack_public_path__ + "static/media/avatarImage.364dce1d.png";